export const LOCALES = [ 'en', 'zh-CN', 'zh-TW' ] as const;

export type Locale = typeof LOCALES[number];

export type TranslationKey =
  | 'app_error.403.text'
  | 'app_error.403.title'
  | 'app_error.404.text'
  | 'app_error.404.title'
  | 'app_error.422.text'
  | 'app_error.422.title'
  | 'app_error.500.text'
  | 'app_error.500.title'
  | 'common.all'
  | 'common.age'
  | 'common.add_address'
  | 'common.add_api_key'
  | 'common.add_token_to_wallet'
  | 'common.apple'
  | 'common.api_documentation_unavailable'
  | 'common.back_to_home'
  | 'common.address'
  | 'common.balance'
  | 'common.balance_with_symbol'
  | 'common.category'
  | 'common.base_fee'
  | 'common.block'
  | 'common.block_confirmations'
  | 'common.burnt_fees'
  | 'common.bytes'
  | 'common.call'
  | 'common.batch'
  | 'common.constructor_args'
  | 'common.contract'
  | 'common.contract_address'
  | 'common.copy'
  | 'common.copy_link_to_clipboard'
  | 'common.copy_to_clipboard'
  | 'common.copied'
  | 'common.current_block'
  | 'common.default'
  | 'common.details'
  | 'common.documentation'
  | 'common.error.try_refresh'
  | 'common.estimated_target_date'
  | 'common.fast'
  | 'common.fee'
  | 'common.first'
  | 'common.filter'
  | 'common.from'
  | 'common.from_to'
  | 'common.gas_price'
  | 'common.gas_used'
  | 'common.google'
  | 'common.hide_scam_tokens'
  | 'common.hide'
  | 'common.hide_details'
  | 'common.history'
  | 'common.how_to_use_blockscout_api_key'
  | 'common.hex'
  | 'common.info'
  | 'common.inventory'
  | 'common.l1_txn'
  | 'common.l1_txn_hash'
  | 'common.l2_txn'
  | 'common.l2_txn_hash'
  | 'common.language'
  | 'common.language_compiler_version'
  | 'common.last_update'
  | 'common.license'
  | 'common.left'
  | 'common.l2_block_no'
  | 'common.links'
  | 'common.load_high'
  | 'common.load_low'
  | 'common.load_medium'
  | 'common.logs'
  | 'common.lookup_related_domains'
  | 'common.loading'
  | 'common.normal'
  | 'common.no_data'
  | 'common.no_data_short'
  | 'common.no_data_selected_interval'
  | 'common.no_results'
  | 'common.no_results_found'
  | 'common.no_blocks'
  | 'common.no_transactions'
  | 'common.holders'
  | 'common.holder'
  | 'common.id_short'
  | 'common.index'
  | 'common.on_chain_market_cap'
  | 'common.owner'
  | 'common.optimization'
  | 'common.parent_txn_hash'
  | 'common.per_transaction'
  | 'common.percentage'
  | 'common.pending_claim'
  | 'common.price'
  | 'common.priority'
  | 'common.next_page'
  | 'common.need_help_contact_admin'
  | 'common.prev_page'
  | 'common.quantity'
  | 'common.rank'
  | 'common.raw'
  | 'common.remaining_blocks'
  | 'common.reward'
  | 'common.reset'
  | 'common.reset_zoom'
  | 'common.sender'
  | 'common.select_chain'
  | 'common.select_interval'
  | 'common.select_type'
  | 'common.settings'
  | 'common.size'
  | 'common.size_bytes'
  | 'common.slow'
  | 'common.show_info'
  | 'common.success'
  | 'common.failed'
  | 'common.pending'
  | 'common.status'
  | 'common.timestamp'
  | 'common.time_left'
  | 'common.this_tool'
  | 'common.to'
  | 'common.testnet_transaction_only'
  | 'common.toggle_time_format'
  | 'common.total_contracts'
  | 'common.transfers'
  | 'common.tx_hash'
  | 'common.txn_hash'
  | 'common.txn'
  | 'common.txn_count'
  | 'common.txs'
  | 'common.type'
  | 'common.utf8'
  | 'common.method'
  | 'common.method_id'
  | 'common.msg_nonce'
  | 'common.name'
  | 'common.token'
  | 'common.token_id'
  | 'common.user_op_hash'
  | 'common.user'
  | 'common.validator_index'
  | 'common.value'
  | 'common.view_all'
  | 'common.view_details'
  | 'common.view_all_results'
  | 'common.verified'
  | 'common.verified_contracts'
  | 'common.verify_with'
  | 'common.verify_with_other_explorers'
  | 'common.website_settings'
  | 'common.widgets'
  | 'common.zk_compiler'
  | 'common.for_assistance'
  | 'common.account_history'
  | 'common.address_from'
  | 'common.address_to'
  | 'common.amount'
  | 'common.amount_from'
  | 'common.amount_to'
  | 'common.and_or'
  | 'common.api_documentation'
  | 'common.asset'
  | 'common.asset_flows'
  | 'common.authorizations'
  | 'common.base'
  | 'common.blob_fee'
  | 'common.blob_gas_fees'
  | 'common.blob_gas_usage'
  | 'common.blobs'
  | 'common.code'
  | 'common.coin_transfer'
  | 'common.coin_balance_history'
  | 'common.columns'
  | 'common.commitment_tx'
  | 'common.confirmation_tx'
  | 'common.contract_creation'
  | 'common.confirmed_within'
  | 'common.confirmed_within_lte'
  | 'common.confirmed_within_range'
  | 'common.date_from'
  | 'common.date_to'
  | 'common.data'
  | 'common.decimals'
  | 'common.decoded_input_data'
  | 'common.dapp'
  | 'common.epoch_rewards'
  | 'common.eth_rpc_api'
  | 'common.exclude'
  | 'common.find_by_function_name_method_id'
  | 'common.finalized'
  | 'common.gas_fees'
  | 'common.gas_limit'
  | 'common.gas_used_for_l1'
  | 'common.gas_used_for_l2'
  | 'common.gas_usage_and_limit_by_txn'
  | 'common.graphql_api'
  | 'common.include'
  | 'common.indexed'
  | 'common.incoming_message'
  | 'common.interacted_with_contract'
  | 'common.internal_txns'
  | 'common.interop_target'
  | 'common.kettle'
  | 'common.l1_fee'
  | 'common.l1_fee_scalar'
  | 'common.l1_gas_price'
  | 'common.l1_gas_used'
  | 'common.l1_gas_used_by_txn'
  | 'common.l2_status_and_method'
  | 'common.market_cap'
  | 'common.max'
  | 'common.max_priority'
  | 'common.max_total_supply'
  | 'common.metadata'
  | 'common.network_fee'
  | 'common.no_tokens_found'
  | 'common.nonce'
  | 'common.outgoing_message'
  | 'common.popular'
  | 'common.poster_fee'
  | 'common.raw_input'
  | 'common.raw_trace'
  | 'common.rest_api'
  | 'common.rpc_api_endpoints'
  | 'common.select_mode'
  | 'common.sequence_tx_hash'
  | 'common.smart_contract_or_address'
  | 'common.show_all'
  | 'common.syncing_with_base_layer'
  | 'common.validated_by'
  | 'common.state'
  | 'common.revert_reason'
  | 'common.status_and_method'
  | 'common.confirmation_status'
  | 'common.contract_execution_completed'
  | 'common.contract_execution_error'
  | 'common.contract_execution_status'
  | 'common.could_not_determine'
  | 'common.execution_fee'
  | 'common.blocks_mined'
  | 'common.blocks_posted'
  | 'common.blocks_sequenced'
  | 'common.blocks_validated'
  | 'common.interop_relay_tx'
  | 'common.interop_source_tx'
  | 'common.interop_status'
  | 'common.l1_commit_scalar'
  | 'common.l1_block_height'
  | 'common.l1_blob_fees'
  | 'common.l1_data_fee'
  | 'common.l1_fee_overhead'
  | 'common.l1_gas_fees'
  | 'common.message_id'
  | 'common.mined_by'
  | 'common.other'
  | 'common.payload'
  | 'common.position'
  | 'common.posted_by'
  | 'common.queue_index'
  | 'common.ready_for_relay'
  | 'common.relayed'
  | 'common.reorged_block'
  | 'common.scalar'
  | 'common.sequenced_by'
  | 'common.settlement_pending'
  | 'common.target'
  | 'common.tokens_burnt'
  | 'common.tokens_created'
  | 'common.tokens_minted'
  | 'common.tokens_transferred'
  | 'common.transaction_details'
  | 'common.transaction_fee'
  | 'common.transaction_hash'
  | 'common.transactions'
  | 'common.txn_batch'
  | 'common.block_height'
  | 'common.uncle_block'
  | 'common.type_of_transfer'
  | 'common.user_operations'
  | 'common.verify_tx_hash'
  | 'common.view_next_block'
  | 'common.view_previous_block'
  | 'common.waiting'
  | 'common.waiting_for_confirmation'
  | 'common.withdrawal_status'
  | 'common.l1_status'
  | 'home.blockchain_explorer'
  | 'home.average_block_time'
  | 'home.btc_locked_in_2wp'
  | 'home.current_epoch'
  | 'home.daily_operational_txs'
  | 'home.daily_operational_txs_hint'
  | 'home.daily_txs'
  | 'home.daily_txs_hint'
  | 'home.deposits_l1_l2_txn'
  | 'home.explorer'
  | 'home.finalized_epoch'
  | 'home.latest_batch'
  | 'home.latest_batches'
  | 'home.latest_l1_state_batch'
  | 'home.latest_blocks'
  | 'home.latest_transactions'
  | 'home.latest_txn'
  | 'home.market_cap'
  | 'home.market_cap_hint'
  | 'home.network_utilization'
  | 'home.token_price'
  | 'home.token_price_hint'
  | 'home.total_blocks'
  | 'home.total_operational_transactions'
  | 'home.total_transactions'
  | 'home.transactions'
  | 'transactions.avg_transaction_fee'
  | 'transactions.pending_transactions'
  | 'transactions.transaction_fees'
  | 'tokens.all'
  | 'tokens.bridged'
  | 'tokens.bridged_description'
  | 'tokens.crypto_markets'
  | 'tokens.description_support_info'
  | 'tokens.empty_filtered'
  | 'tokens.no_tokens'
  | 'tokens.no_holders'
  | 'tokens.no_owner_tokens'
  | 'tokens.placeholder'
  | 'tokens.title'
  | 'tokens.title_with_network'
  | 'tokens.filtered_by_owner'
  | 'tokens.owner_hint'
  | 'tokens.creator'
  | 'tokens.creator_hint'
  | 'tokens.token_id_hint'
  | 'tokens.transfers_hint'
  | 'tokens.dapp_hint'
  | 'tokens.metadata.error_title'
  | 'tokens.metadata.refresh_failed'
  | 'tokens.metadata.please_wait'
  | 'tokens.metadata.refetch_request_sent'
  | 'tokens.metadata.unable_to_initialize'
  | 'tokens.metadata.success_title'
  | 'tokens.metadata.refreshed'
  | 'tokens.metadata.sending_request'
  | 'tokens.metadata.recaptcha_missing'
  | 'tokens.metadata.refresh'
  | 'tokens.metadata.no_metadata'
  | 'tokens.metadata.refresh_error_title'
  | 'tokens.metadata.refresh_error_desc'
  | 'tokens.metadata.table'
  | 'token_transfers.address_filter'
  | 'token_transfers.incoming'
  | 'token_transfers.no_token_transfers'
  | 'token_transfers.outgoing'
  | 'token_transfers.title'
  | 'token_transfer.type.token_minting'
  | 'token_transfer.type.token_burning'
  | 'token_transfer.type.token_spawning'
  | 'token_transfer.type.token_transfer'
  | 'home.tvl'
  | 'home.tvl_hint'
  | 'home.tx_per_day'
  | 'home.view_all_batches'
  | 'home.view_all_blocks'
  | 'home.view_all_deposits'
  | 'home.view_all_transactions'
  | 'home.view_all_watch_list_transactions'
  | 'home.wallet_addresses'
  | 'language.english'
  | 'language.label'
  | 'language.simplified_chinese'
  | 'language.traditional_chinese'
  | 'nav.api'
  | 'nav.api_keys'
  | 'nav.advanced_filter'
  | 'nav.blocks'
  | 'nav.blockchain'
  | 'nav.charts_stats'
  | 'nav.brand_name_zh'
  | 'nav.brand_name_en'
  | 'nav.custom_abi'
  | 'nav.dapps'
  | 'nav.deposits_l1_l2'
  | 'nav.dex_tracker'
  | 'nav.dispute_games'
  | 'nav.epochs'
  | 'nav.gas_tracker'
  | 'nav.internal_transactions'
  | 'nav.interop_messages'
  | 'nav.mud_worlds'
  | 'nav.name_services_lookup'
  | 'nav.operations'
  | 'nav.other'
  | 'nav.output_roots'
  | 'nav.private_tags'
  | 'nav.submit_public_tag'
  | 'nav.token_transfers'
  | 'nav.tokens'
  | 'nav.top_accounts'
  | 'nav.transactions'
  | 'nav.txn_batches'
  | 'nav.txn_withdrawals'
  | 'nav.user_operations'
  | 'nav.validators'
  | 'nav.verified_addrs'
  | 'nav.verified_contracts'
  | 'nav.verify_contract'
  | 'nav.watch_list'
  | 'nav.withdrawals'
  | 'nav.withdrawals_l2_l1'
  | 'accounts.no_accounts'
  | 'network.chains_list'
  | 'network.menu'
  | 'network.mainnets'
  | 'network_role.miner'
  | 'network_role.poster'
  | 'network_role.sequencer'
  | 'network_role.validator'
  | 'network.other'
  | 'network.testnets'
  | 'network_validation.mined'
  | 'network_validation.posted'
  | 'network_validation.sequenced'
  | 'network_validation.validated'
  | 'page.block_countdown'
  | 'page.block_countdown.description'
  | 'page.block_countdown.placeholder'
  | 'page.blob.details'
  | 'page.blocks.all'
  | 'page.blocks.forked'
  | 'page.blocks.uncles'
  | 'page.advanced_filter.filtered_by'
  | 'page.advanced_filter.no_match'
  | 'page.advanced_filter.reset_filters'
  | 'page.api_keys.description'
  | 'page.api_keys.limit_notice'
  | 'page.contract_verification.new_title'
  | 'page.contract_verification.title'
  | 'contract_verification.address_heading'
  | 'contract_verification.address_placeholder'
  | 'contract_verification.license_placeholder'
  | 'contract_verification.license_hint'
  | 'contract_verification.method_heading'
  | 'contract_verification.method_heading_tooltip'
  | 'contract_verification.method_placeholder'
  | 'contract_verification.verify_publish'
  | 'contract_verification.verify_publish_loading'
  | 'contract_verification.success_title'
  | 'contract_verification.success_description'
  | 'contract_verification.error_title'
  | 'contract_verification.socket_error'
  | 'contract_verification.already_verified'
  | 'contract_verification.not_smart_contract'
  | 'contract_verification.something_wrong'
  | 'contract_verification.method.flattened_code'
  | 'contract_verification.method.standard_input'
  | 'contract_verification.method.sourcify'
  | 'contract_verification.method.multi_part'
  | 'contract_verification.method.vyper_code'
  | 'contract_verification.method.vyper_multi_part'
  | 'contract_verification.method.vyper_standard_input'
  | 'contract_verification.method.solidity_hardhat'
  | 'contract_verification.method.solidity_foundry'
  | 'contract_verification.method.stylus_github'
  | 'contract_verification.method_hint.flattened_code'
  | 'contract_verification.method_hint.multi_part'
  | 'contract_verification.method_hint.sourcify'
  | 'contract_verification.method_hint.standard_input'
  | 'contract_verification.method_hint.standard_input_link'
  | 'contract_verification.method_hint.vyper_code'
  | 'contract_verification.method_hint.vyper_multi_part'
  | 'contract_verification.method_hint.vyper_standard_input'
  | 'contract_verification.method_hint.vyper_standard_input_link'
  | 'contract_verification.method_hint.solidity_hardhat'
  | 'contract_verification.method_hint.solidity_foundry'
  | 'contract_verification.method_hint.stylus_github'
  | 'contract_verification.title.flattened_code'
  | 'contract_verification.title.standard_input'
  | 'contract_verification.title.sourcify'
  | 'contract_verification.title.multi_part'
  | 'contract_verification.title.vyper_code'
  | 'contract_verification.title.vyper_multi_part'
  | 'contract_verification.title.vyper_standard_input'
  | 'contract_verification.title.solidity_hardhat'
  | 'contract_verification.title.solidity_foundry'
  | 'contract_verification.title.stylus_github'
  | 'contract_verification.field.contract_name'
  | 'contract_verification.field.contract_code'
  | 'contract_verification.field.compiler'
  | 'contract_verification.field.evm_version'
  | 'contract_verification.field.constructor_args'
  | 'contract_verification.field.optimization_runs'
  | 'contract_verification.field.library_name'
  | 'contract_verification.field.library_item_title'
  | 'contract_verification.hint.library_name'
  | 'contract_verification.hint.library_address'
  | 'contract_verification.field.library_address'
  | 'contract_verification.field.github_repo_url'
  | 'contract_verification.field.commit_hash'
  | 'contract_verification.field.path_prefix'
  | 'contract_verification.field.zk_compiler'
  | 'contract_verification.field.optimization_enabled'
  | 'contract_verification.field.is_yul'
  | 'contract_verification.field.autodetect_constructor_args'
  | 'contract_verification.field.add_libraries'
  | 'contract_verification.field.standard_input_json'
  | 'contract_verification.field.include_nightly'
  | 'contract_verification.hint.compiler_solidity'
  | 'contract_verification.hint.constructor_args'
  | 'contract_verification.hint.evm_version'
  | 'contract_verification.hint.evm_version_link'
  | 'contract_verification.hint.zk_compiler'
  | 'contract_verification.hint.contract_code_library'
  | 'contract_verification.hint.contract_name'
  | 'contract_verification.hint.contract_name_prefix'
  | 'contract_verification.hint.contract_name_suffix'
  | 'contract_verification.hint.vyper_contract_name'
  | 'contract_verification.hint.standard_input'
  | 'contract_verification.hint.multipart_sources'
  | 'contract_verification.hint.multipart_sources_title'
  | 'contract_verification.hint.sourcify_title'
  | 'contract_verification.hint.sourcify'
  | 'contract_verification.hint.vyper_multipart_main_title'
  | 'contract_verification.hint.vyper_multipart_main'
  | 'contract_verification.hint.vyper_multipart_interfaces_title'
  | 'contract_verification.hint.vyper_multipart_interfaces_prefix'
  | 'contract_verification.hint.vyper_multipart_interfaces_link'
  | 'contract_verification.hint.vyper_multipart_interfaces_suffix'
  | 'contract_verification.hint.path_prefix'
  | 'contract_verification.hint.hardhat_tutorial'
  | 'contract_verification.hint.hardhat_tutorial_link'
  | 'contract_verification.hint.foundry_tutorial'
  | 'contract_verification.hint.foundry_tutorial_link'
  | 'contract_verification.hint.latest_commit_found'
  | 'contract_verification.hint.click_here'
  | 'contract_verification.file.drop_file'
  | 'contract_verification.file.drop_files'
  | 'contract_verification.file.field_required'
  | 'contract_verification.file.wrong_file_type'
  | 'contract_verification.file.file_too_big'
  | 'contract_verification.file.one_file_only'
  | 'contract_verification.validation.github_not_found'
  | 'contract_verification.validation.invalid_github_url'
  | 'contract_verification.validation.commit_not_found'
  | 'page.csv_export.title'
  | 'page.chart.select_resolution'
  | 'page.chart.period'
  | 'page.chart.resolution'
  | 'page.chart.resolution_short'
  | 'page.chart.menu.share'
  | 'page.chart.menu.copy_link'
  | 'page.chart.menu.view_fullscreen'
  | 'page.chart.menu.save_png'
  | 'page.chart.menu.save_csv'
  | 'page.chart.menu.options'
  | 'page.computor_transactions.title'
  | 'page.deposits.no_deposits'
  | 'page.deposits.total_found'
  | 'page.epochs.no_epochs'
  | 'page.transactions.blob_txns'
  | 'page.transactions.pending'
  | 'page.transactions.title'
  | 'page.transactions.title_with_network'
  | 'page.dispute_games.no_dispute_games'
  | 'page.dispute_games.summary'
  | 'page.gas_tracker.last_updated'
  | 'page.gas_tracker.faq'
  | 'page.gas_tracker.faq_a1'
  | 'page.gas_tracker.faq_a2'
  | 'page.gas_tracker.faq_a3'
  | 'page.gas_tracker.faq_a4'
  | 'page.gas_tracker.faq_q1'
  | 'page.gas_tracker.faq_q2'
  | 'page.gas_tracker.faq_q3'
  | 'page.gas_tracker.faq_q4'
  | 'page.gas_tracker.no_recent_data'
  | 'page.gas_tracker.overview'
  | 'page.gas_tracker.price_history'
  | 'page.gas_tracker.track_fees'
  | 'page.gas_tracker.title_with_network'
  | 'page.internal_txs.empty_filtered'
  | 'page.internal_txs.no_internal_txs'
  | 'page.internal_txs.placeholder'
  | 'page.interop_messages.no_messages'
  | 'page.interop_messages.total_found'
  | 'page.mud_worlds.no_worlds'
  | 'page.my_profile.title'
  | 'page.name.details'
  | 'page.name_domains.empty_filtered'
  | 'page.name_domains.no_domains'
  | 'page.name_domains.title_with_network'
  | 'page.operation.details'
  | 'page.operations.no_operations'
  | 'page.operations.empty_filtered'
  | 'page.operations.placeholder'
  | 'page.output_roots.no_output_roots'
  | 'page.output_roots.summary'
  | 'page.pools.no_pools'
  | 'page.pools.empty_filtered'
  | 'page.pools.placeholder'
  | 'page.pool.lp_token_hint'
  | 'page.marketplace.placeholder'
  | 'page.my_profile.description'
  | 'page.search_result.title'
  | 'page.search_result.matching_results'
  | 'page.search_results.title'
  | 'page.search_results.result_header'
  | 'page.sol2uml.title'
  | 'page.sol2uml.for_contract'
  | 'page.txn_batches.no_txn_batches'
  | 'page.txn_batches.summary'
  | 'page.txn_withdrawals.empty_filtered'
  | 'page.txn_withdrawals.invalid_tx_hash'
  | 'page.txn_withdrawals.relayer_hint'
  | 'page.transaction_info'
  | 'page.user_op.details'
  | 'page.user_ops.no_user_ops'
  | 'page.verified_contracts.empty_filtered'
  | 'page.verified_contracts.no_verified_contracts'
  | 'page.verified_contracts.placeholder'
  | 'page.verified_contracts.title_with_network'
  | 'page.verified_contracts.sort_balance_asc'
  | 'page.verified_contracts.sort_balance_desc'
  | 'page.verified_contracts.sort_txs_count_asc'
  | 'page.verified_contracts.sort_txs_count_desc'
  | 'page.withdrawals.no_withdrawals'
  | 'page.withdrawals.processed_summary'
  | 'page.withdrawals.title_with_network'
  | 'page.withdrawals.total_found'
  | 'page.user_ops.title_with_network'
  | 'page.validator.details'
  | 'page.validators.empty_filtered'
  | 'page.validators.no_validators'
  | 'page.verified_addresses.my_title'
  | 'page.verified_addresses.back_to_my'
  | 'page.verified_addresses.before_start'
  | 'page.verified_addresses.deployed_on'
  | 'page.verified_addresses.description'
  | 'page.verified_addresses.get_started'
  | 'page.verified_addresses.token_info_form'
  | 'page.verified_addresses.verified_source_code_prefix'
  | 'page.verified_addresses.verified_source_code_suffix'
  | 'page.watch_list.description'
  | 'page.address.contract_details'
  | 'page.address.contract_details_on'
  | 'page.address.details'
  | 'page.address.details_on'
  | 'page.address.checking_contract_verification'
  | 'page.address.contract_successfully_verified'
  | 'page.address.contract_not_verified_automatically'
  | 'page.address.contract_creation_code'
  | 'page.address.contract_selfdestructed_after_deployment'
  | 'page.address.contract_creation_failed'
  | 'page.address.verify_and_publish'
  | 'page.address.deployed_bytecode'
  | 'page.address.click_to_view_qr'
  | 'page.address.show_qr'
  | 'page.address.unable_to_generate_qr'
  | 'page.address.address_qr_code'
  | 'page.address.token_label'
  | 'page.address.token_name'
  | 'page.address.token_name_hint'
  | 'page.address.contract_name'
  | 'page.address.contract_name_hint'
  | 'page.address.validator_name'
  | 'page.address.validator_name_hint'
  | 'page.address.creator'
  | 'page.address.creator_hint'
  | 'page.address.balance'
  | 'page.address.balance_hint'
  | 'page.address.tokens'
  | 'page.address.tokens_hint'
  | 'page.address.net_worth'
  | 'page.address.net_worth_hint'
  | 'page.address.transactions'
  | 'page.address.transactions_hint'
  | 'page.address.transfers'
  | 'page.address.transfers_hint'
  | 'page.address.gas_used'
  | 'page.address.gas_used_hint'
  | 'page.address.last_balance_update'
  | 'page.address.last_balance_update_hint'
  | 'page.address.widgets_hint'
  | 'page.address.at_txn'
  | 'page.address.filecoin_id'
  | 'page.address.filecoin_id_hint'
  | 'page.address.filecoin_actor'
  | 'page.address.filecoin_actor_hint'
  | 'page.address.filecoin_eth_address'
  | 'page.address.filecoin_eth_address_hint'
  | 'page.address.outgoing_transactions'
  | 'page.address.incoming_transactions'
  | 'page.address.no_internal_txs'
  | 'page.address.no_logs'
  | 'page.address.no_coin_balance_history'
  | 'page.address.no_tokens_of_type'
  | 'page.address.empty_filtered_transactions'
  | 'page.address.empty_filtered_token_transfers'
  | 'page.address.by_collection'
  | 'page.address.list'
  | 'page.address.nfts'
  | 'page.address.view_in_collection'
  | 'page.address.view_all_nfts'
  | 'page.address.items_count'
  | 'page.address.tokens_count'
  | 'page.address.delta'
  | 'page.address.balances'
  | 'page.address.insufficient_chart_data'
  | 'page.api_docs.blockscout_core_api'
  | 'page.api_docs.eth_rpc_api_description'
  | 'page.api_docs.name_service_api'
  | 'page.api_docs.rpc_api_description'
  | 'page.api_docs.stats_api'
  | 'page.api_docs.tac_operation_lifecycle_api'
  | 'page.api_docs.title'
  | 'page.api_docs.title_with_network'
  | 'page.api_docs.user_ops_indexer_api'
  | 'page.api_docs.swagger.try_it_out'
  | 'page.api_docs.swagger.cancel'
  | 'page.api_docs.swagger.execute'
  | 'page.api_docs.swagger.clear'
  | 'page.api_docs.swagger.parameters'
  | 'page.api_docs.swagger.responses'
  | 'page.api_docs.swagger.description'
  | 'page.api_docs.swagger.name'
  | 'page.api_docs.swagger.links'
  | 'page.api_docs.swagger.code'
  | 'page.api_docs.swagger.schema'
  | 'page.api_docs.swagger.example_value'
  | 'page.api_docs.swagger.media_type'
  | 'page.api_docs.swagger.no_links'
  | 'page.api_docs.swagger.request_body'
  | 'page.api_docs.swagger.response_headers'
  | 'page.api_docs.swagger.response_body'
  | 'page.api_docs.swagger.loading'
  | 'page.api_docs.swagger.models'
  | 'page.api_docs.swagger.schemas'
  | 'page.api_docs.swagger.model'
  | 'page.api_docs.swagger.show'
  | 'page.api_docs.swagger.hide'
  | 'page.api_docs.swagger.required'
  | 'page.api_docs.swagger.available_values'
  | 'page.api_docs.swagger.response_content_type'
  | 'page.api_docs.swagger.parameter_content_type'
  | 'page.api_docs.swagger.apply'
  | 'page.api_docs.swagger.close'
  | 'page.api_docs.swagger.download'
  | 'page.api_docs.swagger.servers'
  | 'page.api_docs.swagger.authorize'
  | 'page.api_docs.swagger.copy'
  | 'page.api_docs.swagger.unable_to_render'
  | 'page.api_docs.swagger.examples'
  | 'page.api_docs.swagger.request_url'
  | 'page.api_docs.swagger.server_response'
  | 'page.api_docs.swagger.curl'
  | 'page.api_docs.swagger.request_duration'
  | 'page.api_docs.swagger.edit_value'
  | 'page.token.unnamed_token'
  | 'page.token.price_hint'
  | 'page.token.market_cap_hint'
  | 'page.token.max_total_supply_hint'
  | 'page.token.holders_hint'
  | 'page.token.transfers_count_hint'
  | 'page.token.decimals_hint'
  | 'page.token.marketplaces'
  | 'page.token.marketplaces_hint'
  | 'page.transaction.confidential_compute_tx_details'
  | 'page.transaction.details'
  | 'page.transaction.details_on'
  | 'page.transaction.regular_tx_details'
  | 'network.view_all_chains'
  | 'search.category.addresses'
  | 'search.category.blobs'
  | 'search.category.blocks'
  | 'search.category.dapps'
  | 'search.category.names'
  | 'search.category.nfts'
  | 'search.category.operations'
  | 'search.category.public_tags'
  | 'search.category.tokens'
  | 'search.category.transactions'
  | 'search.category.user_operations'
  | 'search.loading'
  | 'search.placeholder_desktop'
  | 'search.placeholder_mobile'
  | 'search.recent'
  | 'search.clear_all'
  | 'settings.color_theme'
  | 'settings.show_address_format'
  | 'socket.connection_lost_prefix'
  | 'socket.connection_lost_link'
  | 'socket.live_updates_delayed'
  | 'socket.item.block'
  | 'socket.item.deposit'
  | 'socket.item.token_transfer'
  | 'socket.item.transaction'
  | 'socket.more_items'
  | 'socket.scanning_new_items'
  | 'home.network_utilization_last_blocks'
  | 'block.reorg_height'
  | 'block.uncle_height'
  | 'block.genesis_block'
  | 'block.l1_height_hint'
  | 'block.batch_hint'
  | 'block.status_hint'
  | 'block.miner_hint'
  | 'block.commitment_tx_hint'
  | 'block.confirmation_tx_hint'
  | 'block.reward_hint'
  | 'block.reward_amount_hint'
  | 'block.static_reward'
  | 'block.txn_fees'
  | 'block.burnt_fees'
  | 'block.view_hint'
  | 'block.gas_used_hint'
  | 'block.gas_limit_hint'
  | 'block.min_gas_price'
  | 'block.min_gas_price_hint'
  | 'block.base_fee_per_gas'
  | 'block.base_fee_per_gas_hint'
  | 'block.burnt_fees_hint'
  | 'block.burnt_fees_utilization_hint'
  | 'block.priority_fee'
  | 'block.priority_fee_hint'
  | 'block.difficulty_hint'
  | 'block.total_difficulty_hint'
  | 'block.hash_hint'
  | 'block.parent_hash_hint'
  | 'block.nonce_hint'
  | 'block.send_count'
  | 'block.send_count_hint'
  | 'block.send_root'
  | 'block.send_root_hint'
  | 'block.delayed_messages'
  | 'block.delayed_messages_hint'
  | 'block.tx_count_label'
  | 'block.blob_tx_count_label'
  | 'block.including'
  | 'block.in_this_block'
  | 'block.height_hint'
  | 'block.size_hint'
  | 'block.timestamp_hint'
  | 'block.transactions_hint'
  | 'block.withdrawals_hint'
  | 'block.difficulty'
  | 'block.total_difficulty'
  | 'block.hash'
  | 'block.parent_hash'
  | 'tx.state.description'
  | 'tx.state.empty'
  | 'tx.state.before_change'
  | 'tx.state.after_change'
  | 'tx.state.change_amount'
  | 'tx.state.mint_address'
  | 'tx.state.burn_address'
  | 'tx.state.miner_tooltip'
  | 'tx.state.mint_burn_tooltip'
  | 'tx.raw_trace.empty'
  | 'tx.logs.empty'
  | 'tx.blobs.empty'
  | 'tx.blobs.blob_hash'
  | 'tx.blobs.data_type'
  | 'tx.internals.empty'
  | 'tx.internals.gas_limit'
  | 'tx.internal.type.call'
  | 'tx.internal.type.delegatecall'
  | 'tx.internal.type.staticcall'
  | 'tx.internal.type.create'
  | 'tx.internal.type.create2'
  | 'tx.internal.type.selfdestruct'
  | 'tx.internal.type.reward'
  | 'tx.token_transfers.empty'
  | 'tx.token_transfers.empty_filtered'
  | 'tx.type.contract_call'
  | 'tx.type.blob_transaction'
  | 'tx.type.token_transfer'
  | 'tx.type.token_creation'
  | 'tx.type.rootstock_remasc'
  | 'tx.type.rootstock_bridge'
  | 'tx.type.transaction'
  | 'tx.asset_flows.wallet'
  | 'tx.asset_flows.actions'
  | 'tx.asset_flows.empty'
  | 'tx.authorizations.empty'
  | 'tx.authorizations.authority'
  | 'tx.authorizations.chain'
  | 'tx.authorizations.chain_this'
  | 'tx.authorizations.chain_any'
  | 'common.additional_info'
  | 'common.txn_type'
  | 'common.more_details'
  | 'tx.hint.transaction_hash'
  | 'tx.hint.status'
  | 'tx.hint.status_details'
  | 'tx.hint.l1_status'
  | 'tx.hint.revert_reason'
  | 'tx.hint.batch_lifecycle'
  | 'tx.hint.block'
  | 'tx.hint.batch_index'
  | 'tx.hint.batch_number'
  | 'tx.hint.batch_index_in_block'
  | 'tx.hint.timestamp'
  | 'tx.hint.confidential_node'
  | 'tx.hint.from'
  | 'tx.hint.to'
  | 'tx.hint.interop_target'
  | 'tx.hint.commitment_tx'
  | 'tx.hint.confirmation_tx'
  | 'tx.hint.value'
  | 'tx.hint.fee'
  | 'tx.hint.fee_without_blob'
  | 'tx.hint.poster_fee'
  | 'tx.hint.execution_fee'
  | 'tx.hint.gas_used'
  | 'tx.hint.l1_data_gas'
  | 'tx.hint.l2_gas_used'
  | 'tx.hint.l1_gas_used'
  | 'tx.hint.l1_gas_used_by_txn'
  | 'tx.hint.l1_gas_price'
  | 'tx.hint.l1_data_fee'
  | 'tx.hint.l1_fee_scalar'
  | 'tx.hint.gas_fees_breakdown'
  | 'tx.hint.blob_fee'
  | 'tx.hint.blob_gas_used'
  | 'tx.hint.blob_eth_used'
  | 'tx.hint.input_data'
  | 'tx.hint.decoded_input_data'
  | 'tx.hint.method'
  | 'tx.hint.gas_limit'
  | 'page.stats.title'
  | 'page.stats.title_with_data'
  | 'page.stats.all_stats'
  | 'page.stats.find_chart'
  | 'page.stats.select_section'
  | 'page.stats.chart_load_error'
  | 'page.stats.chart_load_error_link'
  | 'page.stats.empty_chart'
  | 'stats.interval.all'
  | 'stats.interval.one_month'
  | 'stats.interval.three_months'
  | 'stats.interval.six_months'
  | 'stats.interval.one_year'
  | 'stats.resolution.day'
  | 'stats.resolution.week'
  | 'stats.resolution.month'
  | 'stats.resolution.year'
  | 'block.merged_mining.bitcoin_header'
  | 'block.merged_mining.coinbase_txn'
  | 'block.merged_mining.merkle_proof'
  | 'block.merged_mining.rootstock_hash'
  | 'block.celo_base_fee.handler_label'
  | 'block.celo_base_fee.handler_hint'
  | 'block.celo_base_fee.total_label'
  | 'block.celo_base_fee.total_hint_prefix'
  | 'block.celo_base_fee.total_hint_suffix'
  | 'block.celo_base_fee.burnt'
  | 'block.celo_base_fee.percentage_of_amount'
  | 'block.blob_info.price_label'
  | 'block.blob_info.price_hint'
  | 'block.blob_info.used_label'
  | 'block.blob_info.used_hint'
  | 'block.blob_info.burnt_label'
  | 'block.blob_info.burnt_hint'
  | 'block.blob_info.utilization_tooltip'
  | 'block.blob_info.excess_label'
  | 'block.blob_info.excess_hint'
  | 'block.zilliqa_qc.consensus_explanation'
  | 'block.zilliqa_qc.view_explanation'
  | 'block.zilliqa_qc.signature_explanation'
  | 'block.zilliqa_qc.signers_explanation'
  | 'block.zilliqa_qc.proposed_explanation'
  | 'block.zilliqa_qc.aggregate_quorum_certificate'
  | 'block.zilliqa_qc.quorum_certificate'
  | 'block.zilliqa_qc.view'
  | 'block.zilliqa_qc.signature'
  | 'block.zilliqa_qc.signers'
  | 'block.zilliqa_qc.nested_quorum_certificates'
  | 'block.zilliqa_qc.proposed_by_validator'
  | 'tx.allowed_peekers.label'
  | 'tx.allowed_peekers.hint'
  | 'tx.scroll_fees.l1_fee_hint'
  | 'tx.scroll_fees.l2_fee_hint'
  | 'tx.scroll_fees.scalar_hint'
  | 'tx.scroll_fees.overhead_hint'
  | 'tx.scroll_fees.l1_gas_fees_hint'
  | 'tx.scroll_fees.l1_blob_fees_hint'
  | 'tx.fee_per_gas.hint'
  | 'tx.interop.source_txn_hint'
  | 'tx.interop.relay_txn_hint'
  | 'tx.withdrawal_status_arbitrum.status_hint'
  | 'tx.withdrawal_status_arbitrum.origin_txn_hint'
  | 'tx.gas_price.hint'
  | 'tx.other.hint'
  | 'blob.info.not_indexed'
  | 'blob.info.proof_label'
  | 'blob.info.proof_hint'
  | 'blob.info.commitment_label'
  | 'blob.info.commitment_hint'
  | 'blob.info.size_label'
  | 'blob.info.size_hint'
  | 'blob.info.txn_hash_label'
  | 'blob.info.txn_hash_hint'
  | 'blob.data.not_an_image'
  | 'blob.data.title'
  | 'blob.data.select_type'
  | 'blob.data.download'
  | 'blob.data.format.image'
  | 'blob.data.format.raw'
  | 'blob.data.format.utf8'
  | 'blob.data.format.base64'
  | 'common.originating_l1_txn_hash'
  | 'stats.chart.incomplete_resolution'
  | 'stats.tooltip.date'
  | 'stats.tooltip.dates'
  | 'stats.tooltip.month'
  | 'stats.tooltip.year'
  | 'stats.tooltip.value'
  | 'stats.counter.averageBlockTime.title'
  | 'stats.counter.averageBlockTime.description'
  | 'stats.counter.completedTxns.title'
  | 'stats.counter.completedTxns.description'
  | 'stats.counter.lastNewContracts.title'
  | 'stats.counter.lastNewContracts.description'
  | 'stats.counter.lastNewVerifiedContracts.title'
  | 'stats.counter.lastNewVerifiedContracts.description'
  | 'stats.counter.totalAccounts.title'
  | 'stats.counter.totalAccounts.description'
  | 'stats.counter.totalAddresses.title'
  | 'stats.counter.totalAddresses.description'
  | 'stats.counter.totalBlocks.title'
  | 'stats.counter.totalBlocks.description'
  | 'stats.counter.totalContracts.title'
  | 'stats.counter.totalContracts.description'
  | 'stats.counter.totalNativeCoinTransfers.title'
  | 'stats.counter.totalNativeCoinTransfers.description'
  | 'stats.counter.totalTokens.title'
  | 'stats.counter.totalTokens.description'
  | 'stats.counter.totalTxns.title'
  | 'stats.counter.totalTxns.description'
  | 'stats.counter.totalVerifiedContracts.title'
  | 'stats.counter.totalVerifiedContracts.description'
  | 'stats.counter.newTxns24h.title'
  | 'stats.counter.newTxns24h.description'
  | 'stats.counter.pendingTxns30m.title'
  | 'stats.counter.pendingTxns30m.description'
  | 'stats.counter.txnsFee24h.title'
  | 'stats.counter.txnsFee24h.description'
  | 'stats.counter.averageTxnFee24h.title'
  | 'stats.counter.averageTxnFee24h.description'
  | 'stats.section.accounts.title'
  | 'stats.section.transactions.title'
  | 'stats.section.blocks.title'
  | 'stats.section.tokens.title'
  | 'stats.section.gas.title'
  | 'stats.section.contracts.title'
  | 'stats.section.user_ops.title'
  | 'stats.chart.accountsGrowth.title'
  | 'stats.chart.accountsGrowth.description'
  | 'stats.chart.activeAccounts.title'
  | 'stats.chart.activeAccounts.description'
  | 'stats.chart.newAccounts.title'
  | 'stats.chart.newAccounts.description'
  | 'stats.chart.averageTxnFee.title'
  | 'stats.chart.averageTxnFee.description'
  | 'stats.chart.newTxns.title'
  | 'stats.chart.newTxns.description'
  | 'stats.chart.txnsFee.title'
  | 'stats.chart.txnsFee.description'
  | 'stats.chart.txnsGrowth.title'
  | 'stats.chart.txnsGrowth.description'
  | 'stats.chart.txnsSuccessRate.title'
  | 'stats.chart.txnsSuccessRate.description'
  | 'stats.chart.averageBlockRewards.title'
  | 'stats.chart.averageBlockRewards.description'
  | 'stats.chart.averageBlockSize.title'
  | 'stats.chart.averageBlockSize.description'
  | 'stats.chart.newBlocks.title'
  | 'stats.chart.newBlocks.description'
  | 'stats.chart.newNativeCoinTransfers.title'
  | 'stats.chart.newNativeCoinTransfers.description'
  | 'stats.chart.averageGasLimit.title'
  | 'stats.chart.averageGasLimit.description'
  | 'stats.chart.averageGasPrice.title'
  | 'stats.chart.averageGasPrice.description'
  | 'stats.chart.gasUsedGrowth.title'
  | 'stats.chart.gasUsedGrowth.description'
  | 'stats.chart.networkUtilization.title'
  | 'stats.chart.networkUtilization.description'
  | 'stats.chart.averageGasUsed.title'
  | 'stats.chart.averageGasUsed.description'
  | 'stats.chart.contractsGrowth.title'
  | 'stats.chart.contractsGrowth.description'
  | 'stats.chart.newContracts.title'
  | 'stats.chart.newContracts.description'
  | 'stats.chart.newVerifiedContracts.title'
  | 'stats.chart.newVerifiedContracts.description'
  | 'stats.chart.verifiedContractsGrowth.title'
  | 'stats.chart.verifiedContractsGrowth.description';


export type TranslationValues = Record<string, string | number>;

export type TranslateFn = (key: TranslationKey, values?: TranslationValues) => string;
